import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { recaptchaActions } from "../../store/reducers/recaptcha";
import { uiActions } from "../../store/reducers/ui";

import { CircularProgress, Grid, Typography } from "@mui/material";
import { useCallback } from "react";

const GoogleRecaptcha = () => {
  const [loading, setLoading] = useState(true);

  const recaptchaReset = useSelector((state) => state.recaptcha.reset);
  const recaptchaError = useSelector((state) => state.recaptcha.error);
  const grecaptcha = window["grecaptcha"];

  const dispatch = useDispatch();

  //Next 3 functions are executed after user checks captcha. Using "window" so the recaptcha div recognizes the functions
  window.recaptchaCallback = () => {
    if (grecaptcha) {
      const token = grecaptcha.getResponse();

      if (token) {
        dispatch(recaptchaActions.updateToken(token));
      }
    }
  };

  window.recaptchaExpiredCallback = () => {
    dispatch(
      uiActions.infoMessage({ open: true, type: "warning", message: "reCAPTCHA expired. Please check reCAPTCHA again" })
    );
    dispatch(recaptchaActions.updateToken(""));
  };

  window.recaptchaErrorCallback = () => {
    dispatch(
      uiActions.infoMessage({ open: true, type: "error", message: "reCAPTCHA network error. Please try again" })
    );
    dispatch(recaptchaActions.updateToken(""));
  };

  const resetRecaptcha = useCallback(() => {
    grecaptcha.reset();

    if (recaptchaReset) {
      dispatch(recaptchaActions.updateReset(false));
    }
  }, [dispatch, grecaptcha, recaptchaReset]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      setLoading(false);
    };
  }, []);

  useEffect(() => {
    if (recaptchaError || recaptchaReset) {
      resetRecaptcha(recaptchaReset);
    }
  }, [recaptchaError, dispatch, resetRecaptcha, recaptchaReset]);

  return !loading ? (
    <>
      <div
        className="g-recaptcha"
        data-sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        data-callback="recaptchaCallback"
        data-expired-callback="recaptchaExpiredCallback"
        data-error-callback="recaptchaErrorCallback"
      ></div>
      {recaptchaError && (
        <Typography variant="caption" display="block" color="red">
          {`${recaptchaError}. Try again.`}
        </Typography>
      )}
    </>
  ) : (
    <Grid container justifyContent="center" alignItems="center" columnSpacing={1}>
      <Grid item>
        <CircularProgress />
      </Grid>
      <Grid item>Loading Google reCAPTCHA...</Grid>
    </Grid>
  );
};

export default React.memo(GoogleRecaptcha);
